var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 792,
    height: 820,
    viewBox: "0 0 792 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M395.98 819.056C613.755 819.056 790.296 635.923 790.296 410.018C790.296 184.112 613.755 0.979004 395.98 0.979004C178.205 0.979004 1.66406 184.112 1.66406 410.018C1.66406 635.923 178.205 819.056 395.98 819.056Z",
    stroke: "url(#paint0_linear_5_441)",
    strokeWidth: 1.70914,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_441",
    x1: 395.938,
    y1: 0.454537,
    x2: 395.938,
    y2: 819.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161A24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#161A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161A24",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.9cc39f9cb34cd55b34e1be0ac5968c53.svg";
export { ForwardRef as ReactComponent };